/**
 * Usuarioexpediente Archetype
 * 
 * @author Daniel Lepe
 * Agregada la función quicktableFilters y archetypeUsuarioexpedienteCFG, útiles para filtar en quicktable y 
 * agregar dependencias de configuración Usuarioexpediente => Usuarioexpediente_hijo respectivamente.
 * @date May 22th, 2025
 * @version 1.1
 * 
 * @author Daniel Lepe
 * @date May 22th, 2025
 * @version 1.0
 */

import _ from 'lodash'

const baseController = 'Usuarioexpediente',
    baseIndex = baseController + '/index',
    archetype = () => {
        return [
            {
                key: 'id',
                type: 'hidden'
            },
            {
                key: 'readonly',
                type: 'hidden'
            },
            {
                key: 'expediente_version_id',
                type: 'quicktableSelect',
                label: 'Versión de Expediente',
                valueName: 'expediente_version_id',
                labelName: 'expediente_version_title',
                quicktable: () => import('@/views/Expedientes/ExpedientesQuicktable.vue'),
                // filters: () => {return ['Preselected']}, // Especifica filtros vacíos los filtros.
            },
            
            {
                key: 'usuario_id',
                type: 'hidden',
                label: 'Usuario'
            },
            {
                key: 'usuario_id_admin',
                type: 'hidden',
                label: 'Usuario Administrador'
            },
            [
                {
                    key: 'created',
                    type: 'datetime',
                    label: 'Creación',
                    readonly: true
                },
                {
                    key: 'modified',
                    type: 'datetime',
                    label: 'Fecha de Actualización',
                    readonly: true
                }
            ]
        ]
    },
    captions = [
        {
            key: 'id',
            label: '#'
        },
        {
            key: 'expediente_version_title',
            label: 'Versión de Expediente'
        },
        {
            key: 'usuario',
            label: 'Usuario'
        },
        // {
        //     key: 'usuario_id_admin',
        //     label: 'Usuario Administrador'
        // },
        {
            key: 'created',
            label: 'Creación'
        },
        // {
        //     key: 'modified',
        //     label: 'Fecha de Actualización'
        // },
        {
            key: '_'
        }
    ],
    estatusFilterSample = {
        key: 'estatus',
        required: false, // IF THIS IS TRUE, A DEFAULT OPTION SHOULD BE DEFINED, OTHERWISE THE COMPONENT WILL PICK THE FIRST ITEM IN ROW.
        options: [
            'Activo',
            'Oculto'
            // { key: 'all', label: 'Todos' },
        ],
        default: null,
    },
    quicktableFilters = () => {
        return [
            // estatusFilterSample
        ]
    },
    archetypeUsuarioexpedienteCFG = () => {
        return [
            // { key: 'id', type: 'hidden' },
            // { key: 'Usuarioexpediente_id', type: 'hidden', },
            // { key: 'descriptor', label: 'Description', readonly: true },
        ]
    };

let automodalHandler = (conceptId) => {
    let str = baseController + '/' + 'define' + ((_.isNil(conceptId)) ? '' : ('/' + conceptId));
    // console.log("isNil", _.isNil(conceptId))
    return str;
}


export {
    captions,
    baseIndex,
    archetype, 
    archetypeUsuarioexpedienteCFG, 
    quicktableFilters,
    automodalHandler
}